module.exports = "table{\r\n    border:1px solid #ccc;\r\n}\r\n\r\ntable thead{\r\n    background: #808080;\r\n    color:#fff;    \r\n\r\n}\r\n\r\ntable td{\r\n    text-align: center;\r\n    vertical-align: middle;\r\n    border: 1px solid #ccc; \r\n}\r\n\r\n.btn{\r\n    width:100px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/ultilities/claims/claim-form/claim-form.component.css
// module id = ./src/app/ultilities/claims/claim-form/claim-form.component.css
// module chunks = main